// extracted by mini-css-extract-plugin
export default {"menu":"StatusesPopup_menu__uEYD8","menuItem":"StatusesPopup_menuItem__l8Stc"};